import { createFileRoute } from '@tanstack/react-router'
import { AssetAssessment } from 'pages/assetAssessment/AssetAssessment'

export const Route = createFileRoute('/asset-assessment/$siteID/$unitID')({
  component: RouteComponent,
  staticData: {
    title: 'Asset Assessment',
  },
})

function RouteComponent() {
  const { siteID, unitID } = Route.useParams()

  return <AssetAssessment siteId={siteID} unitId={unitID} />
}
